export const AppRoute = {
  welcome: "/welcome",
  import: "/import",
  settings: "/settings",
  catalog: "/catalog",
  news: "/news",
  deposit: "/deposit",
  history: "/history",
  bank: "/bank",
  swap: "/swap",
  send: "/send",
  market: "/market",
  wallet: "/wallet",
  assets: "/assets",
  nfts: "/nfts",
  congratulations: "/congratulations",
} as const;

export const DepositRoute = {
  index: AppRoute.deposit,
  external: `${AppRoute.deposit}/external`,
} as const;

export const CatalogRoute = {
  index: AppRoute.catalog,
  detail: `${AppRoute.catalog}/:id`,
  detailSlug: `${AppRoute.catalog}/app/:slug`,
  leaders: `${AppRoute.catalog}/:id/leaders`,
  category: `${AppRoute.catalog}/category/:id`,
  taskInfo: `${AppRoute.catalog}/tasks/:id`,
  taskList: `${AppRoute.catalog}/tasks`,
  taskCreate: `${AppRoute.catalog}/tasks/create`,
  taskVerification: `${AppRoute.catalog}/tasks/verification`,
  taskVerificationReview: `${AppRoute.catalog}/tasks/verification/:taskId`,
  taskHistory: `${AppRoute.catalog}/tasks/history`,
  taskConfirmTransactions: `${AppRoute.catalog}/tasks/confirm-transactions`,
  newComment: `${AppRoute.catalog}/:id/comments/new`,
} as const;

export const BankRoute = {
  index: AppRoute.bank,
  tasks: `${AppRoute.bank}/tasks`,
  stake: `${AppRoute.bank}/stake`,
  buy: `${AppRoute.bank}/buy`,
  history: `${AppRoute.bank}/stake/history`,
  referrals: `${AppRoute.bank}/referrals`,
} as const;

export const MarketRoute = {
  index: AppRoute.market,
  list: `${AppRoute.market}/orders`,
  order: `${AppRoute.market}/orders/:orderId`,
  create: `${AppRoute.market}/create`,
  confirm: `${AppRoute.market}/create/confirm`,
  myOrders: `${AppRoute.market}/my-orders`,
} as const;

export const SettingsRoute = {
  index: AppRoute.settings,
  walletSafety: `${AppRoute.settings}/wallet-safety`,
  walletLanguage: `${AppRoute.settings}/wallet-language`,
  connectedApps: `${AppRoute.settings}/connected-apps`,
} as const;

export const AssetsRoute = {
  index: AppRoute.assets,
  nfts: AppRoute.nfts,
  nft: `${AppRoute.nfts}/:address`,
} as const;
